import { render, staticRenderFns } from "./RetailerItem.vue?vue&type=template&id=5d221401&"
import script from "./RetailerItem.vue?vue&type=script&lang=js&"
export * from "./RetailerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports